import React, { FC, memo, useContext } from "react";
// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import DEShadow from "./DEShadow";
// styles
import {
    DEAsset,
    DEContainer,
    DefaultHeaderContainer,
    HalfCardContainer,
    HalfCardDetails,
    NoteVector,
    SeparationLine,
    SwiggyLogo,
    TagLine,
    TagLineHeader,
    TagLineText,
} from "../styles";
// types
import { BottomSheetData } from "@super-ui/components/m2c-swiggy-one-halfcard/types";
// utils
import { isEmpty } from "@swiggy-private/js-utils";
// constants
import {
    M2C_HALFCARD_TEST_IDS,
    DELIVERY_EXECUTIVE_PROPS,
    SWIGGY_LOGO_PROPS,
    DELIVERY_EXECUTIVE,
} from "@super-ui/components/m2c-swiggy-one-halfcard/constants";
// contexts
import { M2CHalfcardContext } from "@super-ui/contexts";

const VariantXpFirst: FC<BottomSheetData> = ({ title, subtitles, note, logoCtx, isOneLite }) => {
    const { deliveryExacutive = DELIVERY_EXECUTIVE } = useContext(M2CHalfcardContext);

    return (
        <>
            {isOneLite && (
                <DEContainer>
                    <DEShadow />
                    <DEAsset data-testid={M2C_HALFCARD_TEST_IDS.DE}>
                        <Image cloudinaryId={deliveryExacutive} {...DELIVERY_EXECUTIVE_PROPS} />
                    </DEAsset>
                </DEContainer>
            )}
            <HalfCardContainer>
                {!isOneLite && !isEmpty(logoCtx?.logo) && (
                    <SwiggyLogo>
                        <Image cloudinaryId={logoCtx?.logo} {...SWIGGY_LOGO_PROPS} />
                    </SwiggyLogo>
                )}

                <HalfCardDetails>
                    <DefaultHeaderContainer>
                        <Text
                            data-testid={M2C_HALFCARD_TEST_IDS.TITLE}
                            variant="V2.heading1.neutral.black"
                            color="text_Highest_Emphasis"
                            dangerouslySetInnerHTML={{ __html: title }}
                        />
                    </DefaultHeaderContainer>

                    {!isEmpty(note) ? (
                        <TagLineHeader data-testid={M2C_HALFCARD_TEST_IDS.NOTE}>
                            <NoteVector isRight={false} />

                            <TagLine>
                                <TagLineText variant="V2.overline.neutral.bold" color="primary">
                                    {note}
                                </TagLineText>
                            </TagLine>

                            <NoteVector />
                        </TagLineHeader>
                    ) : (
                        <SeparationLine />
                    )}

                    {!isEmpty(subtitles) && typeof subtitles !== "string" && (
                        <div data-testid={M2C_HALFCARD_TEST_IDS.SUBTITLE}>
                            {subtitles?.map((subTitle: string) => (
                                <Text
                                    key={subTitle}
                                    variant="V2.body1.neutral.regular"
                                    color="text_Med_Emphasis"
                                    dangerouslySetInnerHTML={{ __html: subTitle }}
                                />
                            ))}
                        </div>
                    )}
                </HalfCardDetails>
            </HalfCardContainer>
        </>
    );
};

export default memo(VariantXpFirst);
